"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isPaidUser = isPaidUser;
exports.getRole = getRole;
exports.formatAddress = formatAddress;

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isPaidUser(user) {
  if (!user || !user.paid_until) {
    return false;
  }
  return (0, _moment2.default)().isBefore(user.paid_until);
}

function getRole(user) {
  if (!user) {
    return "";
  }

  switch (user.role) {
    case "new":
      return "Uusi käyttäjä";
    case "admin":
      return "Ylläpitäjä";
    case "user":
      return "Käyttäjä";
    default:
      return "";
  }
}

function formatAddress(street, code, area) {
  if (!street && !area && !code) {
    return "";
  }
  if (!area && !code) {
    return "" + street;
  }
  if (!area) {
    return street + ", " + code;
  }
  if (!code) {
    return street + ", " + area;
  }
  if (!street) {
    return code + " " + area;
  }
  return street + ", " + code + " " + area;
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/utils/UserUtil.js
 ** module id = 43
 ** module chunks = 0
 **/